// return array of items which are not added to cart
const isNotAdded = (array, cart) => {
    if (array.length > 0) {
        const arr = [];
        array.forEach((el) => {
            if (cart[el.item_type] === 0 || cart[el.item_key] === 0) {
                arr.push(el);
            }
        });
        return arr;
    }
    return [];
};
const getAdditionalProducts = ({ cart, personalizedProducts, performanceBoosts, accessories }) => [
    ...isNotAdded(personalizedProducts, cart),
    ...isNotAdded(performanceBoosts, cart),
    ...isNotAdded(accessories, cart),
];
export default getAdditionalProducts;
